import { useState, useCallback } from 'react';
import { callActionAsync } from '@/utils';

interface ExecuteAction<TResponse, TPayload = void> {
  (actionPayload: TPayload): Promise<TResponse>;
}

function useAsyncAction<TResponse, TPayload = void | never>(
  action: (args: TPayload) => TResponse
) {
  const [isExecuting, setIsExecuting] = useState<boolean>(false);

  const execute: ExecuteAction<TResponse, TPayload> = useCallback(
    (actionPayload: TPayload) =>
      callActionAsync<TResponse, TPayload>(
        action,
        actionPayload,
        setIsExecuting
      ),
    [action]
  );

  return [execute, isExecuting] as const;
}

export default useAsyncAction;
